// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ja5B","content":"styles_content__WE-oa"};